










































import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { Component, Prop, Vue } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

import { ItemGroupResourcePayload, ModalState } from '@/models'

import SwitchListItem from './SwitchListItem.vue'

@Component({
  components: {
    ListItem,
    SwitchListItem,
    ValidationObserver,
    ValidationProvider
  }
})
export default class CreateItemGroupModal extends Vue {
  @Prop({ type: ModalState, required: true })
  readonly modalState!: ModalState

  isValid = false

  title = ''
  isActive = true

  /**
   * This is a hack because ValidationObserver does not emit a status event
   * and its validate() method returns a Promise.
   */
  setIsValid (valid: boolean) {
    this.isValid = valid
  }

  cancel () {
    this.modalState.reset()

    this.title = ''
    this.isActive = true

    this.$emit('cancel')
  }

  submit () {
    if (!this.isValid) {
      return
    }

    const payload: ItemGroupResourcePayload = {
      title: this.title,
      active: this.isActive
    }

    this.$emit('submit', payload)
  }

  submitAndClose () {
    this.modalState.isActive = false
    this.submit()
  }
}
